import 'flag-icons/css/flag-icons.min.css';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import CityAutocomplete from '../../../../components/Display/CityAutocomplete';
import { InputTextarea } from 'primereact/inputtextarea';

function JobOfferPanel({ isOpen, onClose, onCreate, joboffer, onUpdate, loading }) {
  const [title, setTitle] = useState('');
  const [city, setCity] = useState(undefined);
  const [company, setCompany] = useState('');
  const [resume, setResume] = useState('');
  const [placeQuery, setPlaceQuery] = useState('');

  useEffect(() => {
    if (joboffer) {
      setTitle(joboffer.title);
      setResume(joboffer.resume);
      setCity(joboffer.city);
      setCompany(joboffer.company);
      setPlaceQuery(joboffer?.city?.city);
    } else {
      setTitle('');
      setResume('');
      setCity('');
      setPlaceQuery('');
      setCompany('');
    }
  }, [joboffer, isOpen]);

  console.log(joboffer);

  const handleValidate = () => {
    const jobofferPayload = {
      title,
      company,
      place_id: city?.place_id,
      resume
    };
    joboffer ? onUpdate(jobofferPayload) : onCreate(jobofferPayload);
  };

  const formIsValid = () => {
    return title && city && company && resume;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${joboffer ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={<h3>{`${joboffer ? 'Modifier' : 'Ajouter'} une offre d'emploi`}</h3>}>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput key="Nom" label={"Titre de l'offre d'emploi"} required isValid={title}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de l'offre d'emploi"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>

          <FormInput label={'Ville'} required isValid={city}>
            <CityAutocomplete
              setSelectedPlace={setCity}
              placeQuery={placeQuery}
              setPlaceQuery={setPlaceQuery}
            />
          </FormInput>
          <FormInput
            key="company"
            label={"Structure de l'offre d'emploi"}
            required
            isValid={company}>
            <InputText
              id="email"
              value={company}
              maxLength={300}
              placeholder="Veuillez saisir le nom de la structure"
              onChange={(e) => setCompany(e.target.value)}
            />
          </FormInput>
          <FormInput key="resume" label={'Résumé'} required isValid={resume}>
            <InputTextarea
              id="resume"
              rows={3}
              value={resume}
              placeholder="Veuillez saisir le résumé de l'offre d'emploi"
              onChange={(e) => setResume(e.target.value)}
            />
          </FormInput>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default JobOfferPanel;
